import { action } from 'satcheljs';

/**
 * Initializes the OWA Account Store.
 * The store responds by loading the existing connected accounts from the user's mailbox.
 */
export const initializeOwaAccountsStore = action('initializeOwaAccountsStore');

/**
 * Action triggered after a connected account is successfully added
 */
export const owaConnectedAccountAdded = action(
    'owaConnectedAccountAdded',
    (accountSmtpAddress: string) => ({ accountSmtpAddress })
);
